import React, { ReactNode } from "react"

import classNames from "classnames"
import { colorOptions } from "../../../types/options"
import { twMerge } from "tailwind-merge"

export enum BackgroundColor {
    "White" = "#fff",
    "Green" = "#919a76",
    "Grey" = "#f2f0ee",
    "Beige" = "#e9e2d8",
    "DarkBlumine" = "#01273E",
}

export interface BackgroundProps {
    children: ReactNode
    color?: BackgroundColor
    className?: string
}

const Background = ({ children, color = BackgroundColor.White, className }: BackgroundProps) => {
    return (
        <div
            className={twMerge(
                classNames(className, {
                    "bg-linear-to-r from-green-dark via-green-light to-green-dark": color === BackgroundColor.Green,
                    "bg-background-tide": color === BackgroundColor.Grey,
                    "bg-beige-radial": color === BackgroundColor.Beige,
                    "bg-darkblumine": color === BackgroundColor.DarkBlumine,
                })
            )}
        >
            {children}
        </div>
    )
}

export const backgroundOptions = colorOptions<typeof BackgroundColor>(BackgroundColor)
export const backgroundGreyScaleColorsOptions = backgroundOptions.filter(
    option => option.value.color === BackgroundColor.Grey || option.value.color === BackgroundColor.White
)
export const backgroundNeutralColorsOptions = backgroundOptions.filter(
    option =>
        option.value.color === BackgroundColor.White ||
        option.value.color === BackgroundColor.Grey ||
        option.value.color === BackgroundColor.Beige
)

export default Background
